import { TInfoClient } from '../users/types';

export interface TSocketState {
  readonly loading: boolean;
  readonly chat: TChat | null;
  readonly data: {
    chat: TChat;
    users: TInfoClient[];
  } | null;
  readonly room: TRoom | null;
  readonly likedMessage: TMessage | null;
  readonly currentMessage: TMessage | null | undefined;
  readonly event: TShowEvent | null;
  readonly errors?: string | undefined;
}

export interface TDataToJoin {
  event_id: number;
  roomId: number;
  token: string;
}

export interface TDataToEvents {
  event_id: number;
}

export interface TSendMessage {
  event_id: number;
  roomId: number;
  message: string;
  comment: { name: string; message: string } | null;
}

export interface TLikeMessage {
  event_id: number;
  roomId: number;
  messageId: number;
}

export interface TChat {
  messages: TMessage[];
  page: number;
  pages: number;
}

export interface TMessage {
  absnum: number;
  adate: Date;
  comment: { name: string; message: string } | null;
  countLike: number;
  isquestion: 0 | 1;
  isresponse: 0 | 1;
  iscurrent: 0 | 1;
  ispublish: 0 | 1;
  likeUsers: null | { id2: number }[];
  message: string;
  name: string;
  roomId: number;
  typeId: number;
  userId: string;
  privateId: number;
}

export interface TRoom {
  absnum: number;
  name: string;
  youtube: string;
  urlAddInfo: string;
  urlPresentation: string;
  docs?: RoomDocsType[];
  event_id: number;
  messageId: number;
  callActionId: number;
  interId: number;
  interType: number;
  type_id: number;
  isclose: number;
  hideVideo: number;
  questions?: TMessage[] | null;
  pinMessage?: TMessage | null;
}

export interface TShowEvent {
  absnum: number;
  approved: number;
  dateEnd: string;
  dateStart: string;
  ispay: number;
  name: string;
  productCode: string;
  urlAnketa: string;
  urlAbout: string;
  urlHelp: string;
  typeEvent: number;
  isCertificate: number;
  isWebinarCertificate: number;
  isTicket: number;
  group_id: number;
  is_register: number;
  type_id: number;
  cleanurl: string;
  rooms: TRooms[];
  product_id: number;
  baseProduct: number;
}

export interface TRooms {
  absnum: number;
  name: string;
  youtube: string;
  urlAddInfo: string;
  urlPresentation: string;
  event_id: number;
  messageId: number;
  callActionId: number;
  interId: number;
  interType: number;
  type_id: number;
  isclose: number;
  hideVideo: number;
}

export interface TChowChat {
  room: TRoom;
  chat: TChat;
  users: TInfoClient[];
}

export type RoomDocsType = {
  id: number;
  name: string;
  url: string;
  room_id: number;
  created_at: Date;
  updated_at: Date;
};

enum ActionTypes {
  SET_DATA = '@@sockets/SET_DATA',
  SET_ROOM = '@@sockets/SET_ROOM',
  ERROR = '@@sockets/ERROR',

  SHOW_EVENT_R = '@@sockets/SHOW_EVENT_R',
  SHOW_EVENT_S = '@@sockets/SHOW_EVENT_S',
  SHOW_EVENT_E = '@@sockets/SHOW_EVENT_E',

  METRICS_UKD_R = '@@sockets/METRICS_UKD_R',
  METRICS_UKD_S = '@@sockets/METRICS_UKD_S',
  METRICS_UKD_E = '@@sockets/METRICS_UKD_E',

  GET_MESSAGES_R = '@@sockets/GET_MESSAGES_R',
  GET_MESSAGES_S = '@@sockets/GET_MESSAGES_S',
  GET_MESSAGES_E = '@@sockets/GET_MESSAGES_E',

  GET_WEBINAR_CERTIFICATE_R = '@@sockets/GET_WEBINAR_CERTIFICATE_R',
  GET_WEBINAR_CERTIFICATE_S = '@@sockets/GET_WEBINAR_CERTIFICATE_S',
  GET_WEBINAR_CERTIFICATE_E = '@@sockets/GET_WEBINAR_CERTIFICATE_E',

  SEND_MESSAGE_R = '@@sockets/SEND_MESSAGE_R',
  LIKE_MESSAGE_R = '@@sockets/LIKE_MESSAGE_R',

  SET_DELETE_MESSAGE = '@@sockets/SET_DELETE_MESSAGE',
  SET_NEW_MESSAGE = '@@sockets/SET_NEW_MESSAGE',
  SET_UPDATE_MESSAGE = '@@sockets/SET_UPDATE_MESSAGE',
  SET_CHAT = '@@sockets/SET_CHAT',
  SET_CALL_ACTION_ID_ROOM = '@@sockets/SET_CALL_ACTION_ID_ROOM',
}

export default ActionTypes;
